module.exports = __webpack_public_path__ + "static/media/fiona_and_garth.f7af7f56.jpg";